export default __webpack_public_path__ + "static/media/wishlist.82a4bbd6.png";